<template>
<div>
   <div class="whatsapp">
     <a class=" whatsapp-web" target="_blank" href="https://web.whatsapp.com/send?phone=+905063867780&text=Merhaba;%0D%0AArchotek firması,%0D%0Aürünleriniz hakkında detaylı bilgi almak istiyorum."><i class="fa fa-whatsapp"></i></a>
     <a class="whatsapp whatsapp-mobile"  href="https://wa.me/+905063867780/?text=Merhaba;%0D%0AArchotek firması,%0D%0Aürünleriniz hakkında detaylı bilgi almak istiyorum."  data-action="share/whatsapp/share"><i class="fa fa-whatsapp"></i></a>
</div>
  <footer class="footer animatedParent animateOnce" data-sequence="500">
    <div class="container animated bounceInUp go" data-id="1">
      <div class="row">
        <div class="col-md-5 col-xs-12 col-sm-6">
          <div class="box-logo-footer">
            <img src="/static/img/logo.png" alt="">
            <p v-lang.shortaboutus>
            </p>
          </div>
        </div>
       
        <div class="col-md-4 col-xs-12 col-sm-6">
          <h3  v-lang.socialmedia></h3>
          <ul class="last-social">
            <li class="">
              <a href="https://www.facebook.com/ArchoTek-1579210582134240/"><i class="fa fa-facebook"></i></a>
            </li>
            <li class="">
              <a href="https://twitter.com/archo_tek"><i class="fa fa-twitter"></i></a>
            </li>
            <li class="">
              <a href="https://www.instagram.com/archotek.co/?hl=en"><i class="fa fa-instagram"></i></a>
            </li>
            <li class="">
              <a href="https://www.linkedin.com/in/archo-tek-632054159/"><i class="fa fa-linkedin"></i></a>
            </li>
            <li class="">
              <a href="https://www.youtube.com/channel/UCt08-2RXF7XE79R5EYeMifQ"><i class="fa fa-youtube"></i></a>
            </li>

          </ul>
        </div>
        <div class="col-md-3 col-xs-12 col-sm-6">
          <h3 v-lang.contactus></h3>
          <ul class="contact-us">
            <li><i class="fa fa-mobile" aria-hidden="true"></i> <p>00902124221771</p></li>
            <li><i class="fa fa-fax" aria-hidden="true"></i> <p>00902124221741</p></li>
            <li><i class="fa fa-map-marker" aria-hidden="true"></i> <p>Cihangir Mah. Meşrutiyet Cad. Mehtar Sok. No:1A/0 Acvılar - Istanbul/Turkey</p></li>
            <li><i class="fa fa-envelope" aria-hidden="true"></i><p>info@archotek.com</p></li>
          </ul>
          <form class="form-inline">
            <label for="" v-lang.newsletter style="color : #fff;"></label>
            <div class="form-group">
              <div class="input-group">
                <input type="text" class="form-control" id="Newsletter" >
                <div class="input-group-addon"><button><i class="fa fa-send"></i></button></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </footer>
  <div class="copyright">
    <div class="container">
      <div class="row">
        <div class="col-md-8 col-xs-12 col-sm-6">
          <p> All Rights Reserved For Archotek Interior Design L.L.C 2017</p>
        </div>
        <div class="col-md-4 col-xs-12 col-sm-6">
          <p>Design with love  By <a href="http://technologyc2.com/">C2 technology</a></p>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>
<script>
  export default {

  }
</script>



// WEBPACK FOOTER //
// src/components/partials/Footer.vue